import { Immutable } from "immer";
import React from "react";
import { SocialIcons } from "tsi-common-react/src/components/SocialIcons/index";

import { templates } from "@reactivated";

type ICustomerContentHubSocialIconsProps = Immutable<{
    categories: templates.CustomerContentHubStoryPageDocumentTemplate["categories"];
    loveRootUrl: string;
    city?: string | null;
    state?: string | null;
    pageUrl: string;
    tileImageUrl: string;
}>;

export const CustomerContentHubSocialIcons = (
    props: ICustomerContentHubSocialIconsProps,
): React.JSX.Element => {
    return <SocialIcons {...props} twitterHandle="sealy" />;
};
